import MaskedInput from 'react-text-mask'
import styled, { css } from 'styled-components'

import { _M_Normal, mainColors } from '@avantstay/backoffice-core'

export const calendarViewPickerClassName = 'calendar-view-picker'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${mainColors.white};
  padding: 16px 0%;
`

export const PaddingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: inherit;
  padding: 0 16px;
`

export const InputsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const ViewContainer = styled.div`
  max-height: 250px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: auto;
`

export const DatePickerContainer = styled.div`
  position: relative;
  min-height: 250px;
  min-width: 460px;
  overflow: auto;

  .${calendarViewPickerClassName} > div {
    box-shadow: none;
  }
`

export const ViewGrid = styled.div<{ $columns?: number; $marginTop?: number }>`
  display: grid;
  grid-template-columns: ${({ $columns = 3 }) => `repeat(${$columns}, 1fr)`};
  gap: 8px;
  margin-top: ${({ $marginTop = 8 }) => `${$marginTop}px`};
`

export const DateInput = styled(MaskedInput)`
  width: 100%;
  font-size: 13px;
  border: 2px solid ${mainColors.neutralMedium};
  border-radius: 2px;
  padding: 6px 4px;
`

export const ViewPresetButton = styled.button`
  ${_M_Normal};

  min-height: 19px;
  background: ${mainColors.white};
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: 4px;
  color: ${mainColors.black};
  padding: 4px 14px;
  cursor: pointer;

  &:hover {
    border-color: ${mainColors.accentMedium};
    color: ${mainColors.accentMedium};
  }

  &[aria-selected='true'] {
    background: ${mainColors.accentMedium};
    border-color: ${mainColors.accentMedium};
    color: ${mainColors.white};

    &:hover {
      background: ${mainColors.accentDark};
      border-color: ${mainColors.accentDark};
      color: ${mainColors.white};
    }
  }
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  border-top: 1px solid ${mainColors.neutralMedium};
  padding: 16px 16px 0;
`
